import * as constants from './constants';

export const toggleVacancyModal = (flag) => {
  return {
    type: constants.TOGGLE_VACANCY_MODAL,
    flag
  }
}

export const toggleSidebar = (flag) => {
  return {
    type: constants.TOGGLE_SIDEBAR,
    flag
  }
}

export const toggleFormsModal = (flag, tab) => {
  return {
    type: constants.TOGGLE_FORMS_MODAL,
    flag,
    tab
  }
}

export const setClientWidth = (clientWidth) => {
  return {
    type: constants.SET_CLIENT_WIDTH,
    clientWidth
  }
}


export const endAnimation = () => {
  return {
    type: constants.END_ANIMATION
  }
}


// WEBPACK FOOTER //
// ./src/actions.js